import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Notifications from 'vue-notification'


Vue.config.productionTip = false
Vue.prototype.$url = process.env.VUE_APP_API_URL || 'https://api.marinasamont.com' //variable global
Vue.use(Notifications)

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')